import {
    Box,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@material-ui/core";
import React from "react";

import jsonUtils from "../../utils/jsonUtils";
import tratamentoUtils from "../../utils/tratamentoUtils";
import QuadroVisualizacaoLista from "./QuadroVisualizacaoLista";
import QuadroVisualizacaoSimples from "./QuadroVisualizacaoSimples";
import QuadroVisualizacaoListaVertical from "./QuadroVisualizacaoListaVertical";

const QuadroVisualizacaoListaComposta = (props) => {
    const quadro = props.quadro;
    const relatorio = props.relatorio;

    const getDado = (chave_json, tratamento, json, lista = false) => {
        let value = jsonUtils.getValor(chave_json, json, lista);
        return value != undefined
            ? tratamentoUtils.executarTratamento(tratamento, value)
            : lista
            ? []
            : "-";
    };

    const lista = getDado(quadro.dado_loop, "", relatorio, true);

    console.log(lista);

    const field_titulo = quadro.titulo_item;

    return (
        <Box className="zoomPrinter">
            <Typography variant="h5">{quadro.titulo}</Typography>
            <Box style={{ paddingTop: "1rem", paddingBottom: "1rem" }}>
                <Paper
                    style={{ padding: "0.5rem" }}
                    elevation={0}
                    variant="outlined"
                >
                    {lista.map((item, index) => (
                        <Box key={`i${index}`}>
                            <Typography variant="h6">
                                {getDado(field_titulo, "", item, false)}
                            </Typography>
                            {quadro.quadros.map((subQuadro, indexSubQuadro) => {
                                if (subQuadro.tipo == "1") {
                                    return (
                                        <Box
                                            key={`sq${indexSubQuadro}i${index}`}
                                            paddingTop={"0.5rem"}
                                        >
                                            <QuadroVisualizacaoSimples
                                                quadro={subQuadro}
                                                relatorio={item}
                                                subQuadro={true}
                                            />
                                        </Box>
                                    );
                                } else if (subQuadro.tipo == "2") {
                                    return (
                                        <Box
                                            key={`sq${indexSubQuadro}i${index}`}
                                            paddingTop={"0.5rem"}
                                        >
                                            <QuadroVisualizacaoLista
                                                quadro={subQuadro}
                                                relatorio={item}
                                                subQuadro={true}
                                                sizeTitle="h7"
                                                sizeText={11}
                                            />
                                        </Box>
                                    );
                                } else if (subQuadro.tipo == "3") {
                                    return (
                                        <Box
                                            key={`sq${indexSubQuadro}i${index}`}
                                            paddingTop={"0.5rem"}
                                        >
                                            <QuadroVisualizacaoListaVertical
                                                quadro={subQuadro}
                                                relatorio={item}
                                                subQuadro={true}
                                                sizeTitle="h7"
                                                sizeText={12}
                                            />
                                        </Box>
                                    );
                                } else {
                                    return <></>;
                                }
                            })}
                        </Box>
                    ))}
                    {lista.length == 0 && "Nada consta."}
                </Paper>
            </Box>
        </Box>
    );
};

export default QuadroVisualizacaoListaComposta;
